module.exports = __webpack_public_path__ + "img/activatecall.be14d313.png";